var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        app: "",
        "mini-variant": _vm.mini,
        temporary: _vm.$vuetify.breakpoint.xs,
        overlay: _vm.$vuetify.breakpoint.xs,
        fixed: "",
        left: "",
        clipped: "",
        color: "backlight",
      },
      scopedSlots: _vm._u(
        [
          _vm.isAuthenticated
            ? {
                key: "append",
                fn: function () {
                  return [
                    _c("hr"),
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            attrs: { title: "Log Out" },
                            on: { click: _vm.handleLogout },
                          },
                          [
                            _c(
                              "v-list-item-action",
                              [_c("v-icon", [_vm._v("lock")])],
                              1
                            ),
                            _c("v-list-item-content", [_vm._v("Log Out")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              }
            : {
                key: "append",
                fn: function () {
                  return [
                    _c("hr"),
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            attrs: { title: "Log In" },
                            on: { click: _vm.handleLogin },
                          },
                          [
                            _c(
                              "v-list-item-action",
                              [_c("v-icon", [_vm._v("input")])],
                              1
                            ),
                            _c("v-list-item-content", [_vm._v("Log In")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
        ],
        null,
        true
      ),
      model: {
        value: _vm.navModel,
        callback: function ($$v) {
          _vm.navModel = $$v
        },
        expression: "navModel",
      },
    },
    [
      _vm.isAuthenticated
        ? _c(
            "div",
            { staticClass: "transparent", attrs: { flat: "" } },
            [
              _c(
                "v-list",
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: { title: "Model Pipeline", to: "/modelpipeline" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("rocket")])],
                        1
                      ),
                      _c("v-list-item-content", [
                        _c(
                          "div",
                          { staticClass: "float-left" },
                          [
                            _vm._v(" Model Publishes "),
                            _vm.newMpCount > 0
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      title: "New Event",
                                      small: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("flag")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: { title: "Lightning" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("bolt")])],
                        1
                      ),
                      _c("v-list-item-content", [
                        _c(
                          "div",
                          { staticClass: "float-left" },
                          [
                            _vm._v(" Lightning "),
                            _vm.newLightningCount > 0
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      title: "New Event",
                                      small: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("flag")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: { title: "Lightning Publishes", to: "/lightning" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_vm.mini ? _c("v-icon", [_vm._v("link")]) : _vm._e()],
                        1
                      ),
                      _c("v-list-item-content", { staticClass: "ml-3" }, [
                        _vm._v("Fabrication Publishes"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        title: "Lightning Databases",
                        to: "/lightningdatabases",
                      },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_vm.mini ? _c("v-icon", [_vm._v("link")]) : _vm._e()],
                        1
                      ),
                      _c("v-list-item-content", { staticClass: "ml-3" }, [
                        _vm._v("Databases"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        title: "Lightning Catalogs",
                        to: "/lightningcatalogs",
                      },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_vm.mini ? _c("v-icon", [_vm._v("link")]) : _vm._e()],
                        1
                      ),
                      _c("v-list-item-content", { staticClass: "ml-3" }, [
                        _vm._v("Catalog Publishes"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "d-none",
                      attrs: { title: "Import", to: "/import" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("sync_alt")])],
                        1
                      ),
                      _c("v-list-item-content", [
                        _c(
                          "div",
                          { staticClass: "float-left" },
                          [
                            _vm._v(" Import "),
                            _vm.newImportCount > 0
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      title: "New Event",
                                      small: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("flag")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        title: "Package Publishes",
                        to: "/packagePublishes",
                      },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("draw")])],
                        1
                      ),
                      _c("v-list-item-content", [
                        _c(
                          "div",
                          { staticClass: "float-left" },
                          [
                            _vm._v(" Package Publishes "),
                            _vm.newFieldOrderzCount > 0
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      title: "New Event",
                                      small: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("flag")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: { title: "Workflows", to: "/workflows" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("info")])],
                        1
                      ),
                      _c("v-list-item-content", [_vm._v(" Workflows ")]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: { title: "Service Queues", to: "/servicequeues" },
                      on: { click: _vm.closeDrawerOnMobile },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("transform")])],
                        1
                      ),
                      _c("v-list-item-content", [_vm._v(" Service Queues ")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }